import { ExtratoPixFornecedorInicial } from "../models/extratoPixFornecedorModel"
import type { ExtratoPixFornecedorModel } from "../models/extratoPixFornecedorModel"
import {
    ExtratoPixFornecedorActionsTypes,
} from "./extratoPixFornecedorActions"
import type { ExtratoPixFornecedorActions } from "./extratoPixFornecedorActions"

const { CARREGAR, SET_DATA_INICIO, SET_DATA_FIM } = ExtratoPixFornecedorActionsTypes

export function extratoPixFornecedorReducer(
    state: ExtratoPixFornecedorModel = ExtratoPixFornecedorInicial,
    action: ExtratoPixFornecedorActions
): ExtratoPixFornecedorModel {
    switch (action.type) {
        case CARREGAR:
            return {
                ...state,
                grupos: action.payload.grupos,
                resumo: action.payload.resumo,
                saldo: action.payload.saldo,
            }
        case SET_DATA_INICIO:
            return { ...state, dataInicio: action.payload }
        case SET_DATA_FIM:
            return { ...state, dataFim: action.payload }
        default:
            return state
    }
}
